export const EMPLOYEES_BASE_QUERY_KEY = ["employees"] as const;
export const EMPLOYEE_TRANSFER_BASE_QUERY_KEY = ["employeeTransfer"] as const;
export const HELPDESK_BASE_QUERY_KEY = ["helpdesk"] as const;
